import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import './CheckoutHeader.css'

export interface CheckoutHeaderProps {
  /** Hora de salida, p. ej. "11:00" */
  time: ReactNode
  /** Cuenta atrás, p. ej. "2 h 40 min" */
  remaining?: ReactNode
  timeLabel?: ReactNode
  remainingLabel?: ReactNode
  className?: string
}

/** Cabecera de salida (bundle B7): hora en display + cuenta atrás en h2, cifras tabulares, en tarjeta. */
export function CheckoutHeader({ time, remaining, timeLabel, remainingLabel, className }: CheckoutHeaderProps) {
  const { t } = useTranslation()
  return (
    <div className={cx('hp-checkout', className)}>
      <div>
        <div className="hp-checkout__label">{timeLabel ?? t('v2.ds.checkoutHeader.horaSalida')}</div>
        <div className="hp-checkout__time tnum">{time}</div>
      </div>
      {remaining && (
        <div className="hp-checkout__remaining">
          <div className="hp-checkout__label">{remainingLabel ?? t('v2.ds.checkoutHeader.quedan')}</div>
          <div className="hp-checkout__countdown tnum" aria-live="polite">
            {remaining}
          </div>
        </div>
      )}
    </div>
  )
}
